import { useEffect } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { authLoginURL } from '../../constants/urls';

export const Login = () => {
  const [params] = useSearchParams();
  const code = params.get('code') ?? '';
  const navigate = useNavigate();

  useEffect(() => {
    if (code !== '') {
      navigate(`/authorizeUser?code=${code}`);
    }
  }, [code, navigate]);

  return code !== '' ? <div /> : <RedirectToLoginComponent />;
};

const RedirectToLoginComponent = () => {
  const scope = 'head_office_reporting_app';
  const state = 2;
  const responseType = 'code';
  const redirectUri = `${window.location.protocol}//${window.location.host}/login`;

  const authUrl = `${authLoginURL}authorize?redirect_uri=${redirectUri}&state=${state}&scope=${scope}&response_type=${responseType}`;

  window.location.replace(authUrl);
  return <>Redirecting to login page.</>;
};
